import { render, staticRenderFns } from "./BlogSortableList.vue?vue&type=template&id=88c473c6&"
import script from "./BlogSortableList.vue?vue&type=script&lang=js&"
export * from "./BlogSortableList.vue?vue&type=script&lang=js&"
import style0 from "./BlogSortableList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports